import { withUnicodeRouteArrow } from '../../../utils/routeLabelDisplay'

/** Line height (px) between wrapped category-axis tspans. */
export const FLAT_CATEGORY_AXIS_LINE_HEIGHT = 12

/**
 * Breaks a category label into horizontal tick lines (Figma carrier bar chart).
 * Splits `Name (suffix)` onto two lines; otherwise word-wraps near `maxCharsPerLine`.
 */
export const splitFlatCategoryAxisLines = (
  label: string,
  maxCharsPerLine = 14,
): string[] => {
  const text = withUnicodeRouteArrow(label)
  const parenMatch = text.match(/^(.+?)\s+(\(.+\))$/)
  if (parenMatch) {
    return [parenMatch[1], parenMatch[2]]
  }

  if (text.length <= maxCharsPerLine) {
    return [text]
  }

  const words = text.split(/\s+/)
  const lines: string[] = []
  let current = ''

  for (const word of words) {
    const next = current ? `${current} ${word}` : word
    if (next.length > maxCharsPerLine && current) {
      lines.push(current)
      current = word
    } else {
      current = next
    }
  }

  if (current) {
    lines.push(current)
  }

  return lines.length > 0 ? lines : [text]
}
